import imgixLoader from './imgixLoader';

export { imgixLoader };
